module.exports = __webpack_public_path__ + "img/rotate-right.5b6f2907.png";